<div class="progress-bar">
  <div [style.width]="progress + '%'" class="progress-fill" [ngClass]="color"></div>
</div>